import { Card, CardContent } from "@/components/ui/card"

interface StatCardProps {
  value: number;
  label: string;
}

export default function StatCard({ value, label }: StatCardProps) {
  return (
    <Card className="shadow-sm">
      <CardContent>
        <div className="text-2xl font-semibold pb-4">{value}</div>
        <div className="text-sm font-normal">{label}</div>
      </CardContent>
    </Card>
  )
}
